import { __extends } from "tslib";
import { clamp, isNullOrUndefined } from '@awayfl/swf-loader';
import { ASObject } from '@awayfl/avm2';
var BitmapFilter = /** @class */ (function (_super) {
    __extends(BitmapFilter, _super);
    function BitmapFilter() {
        return _super.call(this) || this;
    }
    BitmapFilter.prototype.clone = function () {
        return null;
    };
    BitmapFilter.prototype.toAwayObject = function () {
        return null;
    };
    // Called whenever the class is initialized.
    BitmapFilter.classInitializer = null;
    return BitmapFilter;
}(ASObject));
export { BitmapFilter };
var GradientArrays = /** @class */ (function () {
    function GradientArrays() {
    }
    // colors null or empty - all empty
    // ratios empty - all empty
    // ratios null and alphas null - length: colors, alphas set to 0, ratios set to 0
    // ratios null and alphas != null - length: colors, alphas filled with 1, ratios set to 0
    // ratios not empty and alphas null - length: min(colors,ratios), alphas set to 0
    // ratios not empty and alphas != null - length: min(colors,ratios), alphas filled with 1
    GradientArrays.sanitize = function (colors, alphas, ratios) {
        if (isNullOrUndefined(colors) || colors.length === 0) {
            this.colors = [];
            this.alphas = [];
            this.ratios = [];
        }
        else {
            var len = void 0;
            if (isNullOrUndefined(ratios)) {
                this.colors = this.sanitizeColors(colors);
                len = this.colors.length;
                this.ratios = this.initArray(len);
                if (isNullOrUndefined(alphas)) {
                    this.alphas = this.initArray(len);
                }
                else {
                    this.alphas = this.sanitizeAlphas(alphas, len, len, 1);
                }
            }
            else {
                if (ratios.length === 0) {
                    this.colors = [];
                    this.alphas = [];
                    this.ratios = [];
                }
                else {
                    len = Math.min(colors.length, ratios.length, 16);
                    this.colors = this.sanitizeColors(colors, len);
                    this.ratios = this.sanitizeRatios(ratios, len);
                    if (isNullOrUndefined(alphas)) {
                        this.alphas = this.initArray(len);
                    }
                    else {
                        this.alphas = this.sanitizeAlphas(alphas, len, len, 1);
                    }
                }
            }
        }
    };
    GradientArrays.sanitizeColors = function (colors, maxLen) {
        if (maxLen === void 0) { maxLen = 16; }
        var arr = [];
        for (var i = 0, n = Math.min(colors.length, maxLen); i < n; i++) {
            arr[i] = (colors[i] >>> 0) & 0xffffff;
        }
        return arr;
    };
    GradientArrays.sanitizeAlphas = function (alphas, maxLen, minLen, value) {
        if (maxLen === void 0) { maxLen = 16; }
        if (minLen === void 0) { minLen = 0; }
        if (value === void 0) { value = 0; }
        var arr = [];
        var i;
        var n = Math.min(alphas.length, maxLen);
        for (i = 0; i < n; i++) {
            arr[i] = clamp(+alphas[i], 0, 1);
        }
        while (i < minLen) {
            arr[i++] = value;
        }
        return arr;
    };
    GradientArrays.sanitizeRatios = function (ratios, maxLen, minLen, value) {
        if (maxLen === void 0) { maxLen = 16; }
        if (minLen === void 0) { minLen = 0; }
        if (value === void 0) { value = 0; }
        var arr = [];
        var i;
        var n = Math.min(ratios.length, maxLen);
        for (i = 0; i < n; i++) {
            arr[i] = clamp(+ratios[i], 0, 255);
        }
        while (i < minLen) {
            arr[i++] = value;
        }
        return arr;
    };
    GradientArrays.initArray = function (len, value) {
        if (value === void 0) { value = 0; }
        var arr = Array(len);
        for (var i = 0; i < len; i++) {
            arr[i] = value;
        }
        return arr;
    };
    return GradientArrays;
}());
export { GradientArrays };
